<form [formGroup]="form" (ngSubmit)="check2FactorCode()">
    <div class="modal-body">
        <div class="alert alert-primary workflowPlaceholder border-primary text-body ps-0 pe-2 pb-0" role="alert">
            <span class="lh-base">
                <ol>
                    <li translate="Settings.AccountSecuritySection.Dialog.Instructions1"></li>
                    <li translate="Settings.AccountSecuritySection.Dialog.Instructions2"></li>
                </ol>
            </span>
        </div>

        <div class="d-none d-lg-block mb-3 w-100">
            <qrcode *ngIf="authenticatorData" 
                [qrdata]="authenticatorData.authenticatorUri" 
                [errorCorrectionLevel]="'M'" 
                [allowEmptyString]="true" 
                [cssClass]="'mx-auto d-block p-1 d-block'"
                [elementType]="'img'"></qrcode>
        </div>
        
        <div class="col-12 mb-4">
            <label class="form-label" translate="Settings.AccountSecuritySection.Dialog.AuthenticatorSecret"></label>
            <button class="btn btn-sm default dropdown-toggle text-truncate authenticatorSecret d-block" type="button" id="dropdownMenu">
                <span class="d-block">
                    <em class="bi bi-files float-end" aria-hidden="true" (click)="copyToClipboard()"></em>  
                    {{authenticatorData.sharedKey}}
                </span>
            </button>
        </div>

        <div class="col-12">
            <label for="twoFAkey" class="form-label" translate="Settings.AccountSecuritySection.Dialog.TwoFactorCode"></label>
            <input type="text" id="twoFAkey" formControlName="twoFAkey" class="form-control" placeholder="{{ 'Settings.AccountSecuritySection.Dialog.Code' | translate }}">
        </div>
        
        <div class="border-top-active d-table py-3 w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close()" translate="Button.Back"></button></span>
            <span class="float-end"><button type="submit" class="btn btn-sm btn-primary" [disabled]="!form.valid" (click)="check2FactorCode()" translate="Button.Next"></button></span>
        </div>
    </div>
</form>